import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { IConfigSeller } from '@/models/configSeller'
import NUIAlert from '@/components/Alert/Alert'
import { isConsole } from '@/utils/isConsole'

const NovabencEvaluation: React.FC<any> = () => {
  const { ctx } = useTradeinContext()
  const [questionsLength, setQuestionsLength] = useState(0)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl'
  const isNovabench = (isMacstoreMexico || isFalabellaChile || isRipleyChile) && ctx.tradein.sbu === 'Notebook'

  useEffect(() => {
    const filteredQuestions = ctx.questions.filter((e: any) => {
      const type = isNovabench
        ? 'COMPUTER-NOVABENCH-V2'
        : ctx.tradein.sbu === 'Notebook'
          ? 'COMPUTER'
          : ctx.tradein.sbu === 'Tablet'
            ? 'TABLET'
            : isConsole(ctx.tradein.sbu)
              ? 'PS4'
              : 'SMARTWATCH'
      return e.type.toUpperCase() === type
    })
    console.log('filteredQuestions --->', filteredQuestions)
    if (filteredQuestions.length !== questionsLength) {
      setQuestionsLength(filteredQuestions.length)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.questions, ctx.tradein.sbu, questionsLength])

  console.log('(isNovabench && ctx.statusHistory.includes(2))', ctx)
  return (
    <div className='bg-white rounded-lg shadow-lg p-4' hidden={!isNovabench}>
      <h6 className='border-b-1 mb-2 font-bold text-xl pb-2'>Novabench</h6>
      <div
        className='mt-2'
        hidden={!isNovabench}
      >
        {(isFalabellaChile || isMacstoreMexico || isRipleyChile) && [1].includes(ctx.tradein.id_status) && ctx.tradein.sbu === 'Notebook'
          ? <p className='text-sm p-4 bg-yellow-100 border border-yellow-300 rounded-md text-black mb-4 flex items-center'>No ha realizado evaluacion novabench con el código de evaluación </p>
          : <NUIAlert type='success'>Novabench aprobado</NUIAlert>}
      </div>
    </div>
  )
}

export default NovabencEvaluation
